import { ContentHubData } from "@app/types/ServerCustomContext";

import FullWidthCarousel from "./FullWidthCarousel";

type Props = {
  data?: Omit<ContentHubData, "metaData">;
};

const ContentListCarousel = ({ data }: Props) => {
  if (!data?.contentHubList?.teasers) {
    return null;
  }

  const contentListData = data.contentHubList;

  const config = contentListData.config;

  return (
    <FullWidthCarousel
      title={contentListData.title || ""}
      titleUrl={contentListData.titleUrl || ""}
      teasers={data.contentHubList.teasers}
      backgroundImage={contentListData.backgroundImage}
      backgroundColor={config?.background}
      textColor={config?.color}
    />
  );
};

export default ContentListCarousel;
